<template>
  <div class="h-100">
    <div class="balance-card big-rounded h-100">
      <b-row class="text-center">
        <b-col cols="12" lg="6" sm="12"
          class="border-right-lg-dashed h-lg-50 d-flex justify-content-start b-unique-left">
            <div class="icon-wrap mr-3">
              <img src="@/assets/calendar.svg" alt="Período" class="calendar-icon">
            </div>
              <h4 class="balance-card-title mb-0 mt-2">
              {{ title }} :
              <br />
              <span class="balance-card-subtitle text-md-left text-sm-center d-block">{{ subtitle }}</span>
              </h4>
          <div>
            <p class="balance-card-period d-flex mt-2 ml-3 pl-1 pr-1" v-if="getBalance">
              <span class="balance-card-date d-block">
                {{ getBalance.period.from | abbreviateDate }}
              </span>
              <span class="balance-card-date ml-3 mr-3 d-block">
                <img src="@/assets/arrow-right-acumulate-periodo.svg" alt="arrow-right" />
              </span>
              <span class="balance-card-date d-block">
                {{ getBalance.period.to | abbreviateDate }}
              </span>
            </p>
          </div>
        </b-col>
        <b-col cols="12" lg="6"
          class="d-flex justify-content-start align-items-center text-left b-unique-right"
           v-if="getBalance">
            <div class="icon-wrap mr-3">
              <img src="@/assets/piggybank.svg" alt="Saldo" class="piggybank-icon">
            </div>
            <div>
            <div class="d-flex justify-content-start align-items-center b-unique-right">
              <h4 class="balance-card-title mt-auto mb-auto">
              {{ balanceDescription }}
            </h4>
            <p class="pr-2 pl-2 ml-2 balance-card-value">
              R$ {{ getBalance.value | numberToCurrency }}
            </p>
            </div>
            <small v-if="getBalance.value < 30.00" class="payment-rule">
              Alcance o mínimo de R$ 30,00 para receber.
              <a href="https://afiliados.uol.com.br/faq.html#contract" target="_blank">Ver regulamento</a>
            </small>
            <small v-if="getBalance.value >= 30.00" class="payment-rule mb-0">
              {{ scheduleDescription }} {{ getBalance.expected_to | abbreviateDate }}
            </small>
            </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { abbreviateDate } from '@/utils/dateUtils';
import { numberToCurrency } from '@/utils/currencyUtils';


export default {
  name: 'BalanceCardUnique',
  data() {
    return {
      mode: 'current',
    };
  },
  computed: {
    ...mapGetters(['currentBalance']),
    getBalance() {
      return this.currentBalance;
    },
    title() {
      return 'Período atual';
    },
    subtitle() {
      return 'em aberto';
    },
    toggleActionText() {
      return 'Ver período anterior';
    },
    balanceDescription() {
      return 'Valor acumulado:';
    },
    scheduleDescription() {
      return 'Pagamento previsto para';
    },
  },
  filters: {
    abbreviateDate,
    numberToCurrency,
  },
};
</script>

<style lang="scss" scoped>
.balance-card {
  font-family: $font-1;
  background: url("~@/assets/dollar-sign.svg") right center no-repeat $soft-dark-orange !important;
  color: $text-light;
  text-transform: uppercase;
  padding: 1.5rem 1.5rem 1rem;
}
.calendar-icon {
  width: 24px;
  height: 28px;
}
.piggybank-icon {
  width: 40px;
  height: 40px;
}
.icon-wrap {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.balance-card-title {
  font-size: 18px;
}
.balance-card-subtitle {
  font-size: 14px;
  text-transform: lowercase;
}
.balance-card-period {
  background-color: #AC5B1D;
}
.balance-card-date {
  font-size: 18px;
  font-weight: bold;
}
.balance-card-schedule-date {
  margin-top:4px;
  font-size: 18px;
  font-weight: bold;
}

.balance-card-schedule {
  margin-top: 6px;
  font-size: $font-size-xs-small;
}

.balance-card-value {
  font-size: 18px;
  color:#FFF;
  background: #AC5B1D;
  font-weight: bold;
  margin: 0;
}

.currency {
  font-size: $font-size-lg-small - 2;
}

@media screen and (max-width: 600px){
.b-unique-left{
  flex-direction: column;
  align-items: center;
}

.b-unique-right{
  flex-direction: column;
  align-items: center;
}
.balance-card {
  background: url("~@/assets/dollar-sign.svg") right bottom no-repeat $soft-dark-orange !important;
}
}


.payment-rule{ color: #FFF; opacity: 0.5;}
.payment-rule a{color: #FFF; text-decoration:underline;}

.balance-card-toggle-btn {
  font-size: 0.8em;
  padding: 0.3em 0.75rem;
  text-transform: uppercase;
  width: 100%;
  max-width: 222px;
}
</style>
